import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
@Injectable({
  providedIn: 'root'
})

export class EquipmentCacheService {

   apiServer = environment.apiHost + environment.apiPort;
   
  constructor(public http: HttpClient) { }
  loadAll(subscriber: string, hotelId: number) {
    return this.http.get(this.apiServer + "/api/kip/EquipmentCache/LoadAll/" + subscriber + "/" + hotelId )
  }

}